module.exports = __webpack_public_path__ + "img/shoucangfuwushang.f7997a65.png";